export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f11a0980416a3399ae2af5454f778c76936a994fd&name=fetchTypeahead!'